import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

export const CustomDialog = (props) => {

    const handleCloseWaitingDialog = (_, reason) => {
        if (reason !== 'backdropClick') {
        }
    };

    return (
        <>
        <Dialog
            open={props.show}
            onClose={handleCloseWaitingDialog}
            disableEscapeKeyDown={true}
            >
            <DialogTitle id="alert-dialog-title" >
                {props.title}
            </DialogTitle>
            <DialogContent sx={{
                            margin: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}>

                <h5>{props.content}</h5>
            </DialogContent>
        </Dialog>
        </>
    );
};
